import * as APPCONFIG from "../../src/config/app-config";
import api from "./BaseAPI.js";

export const getLogin = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/login`,
    data: JSON.stringify(formValues),
  });
};

export const saveUser = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/saveUser`,
    data: formValues,
    headers: APPCONFIG.HEADERS_MULTIPART(),
  });
};

export const generateOtp = (form) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/generateOtp`,
    data: form,
  });
};

export const validateOtp = (form) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/validateOtp`,
    data: form,
  });
};
